import React, { useState, useEffect } from "react";
import "./SendResumeJob.css";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import mortarboard from "../../../Assets/img/mortarboard.png";
import Loader from "react-loader-spinner";

function SendResumeEducation() {
  const { id } = useParams();
  const [posts, setPosts] = useState([]);
  const [loader, setLoader] = useState(true);
  const [text, setText] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setLoader(false);
      setText(true);
      return;
    }

    const token = localStorage.getItem("token");

    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/show-study-opportunity-user/${id}`,
        {
          headers: token
            ? {
                Authorization: `Bearer ${token}`,
              }
            : {},
        }
      )
      .then((res) => {
        console.log("Response:", res.data);

        // پشتیبانی از ساختارهای مختلف پاسخ
        let data = [];

        if (Array.isArray(res.data)) {
          data = res.data;
        } else if (res.data?.data && Array.isArray(res.data.data)) {
          data = res.data.data;
        } else if (res.data && typeof res.data === "object") {
          // اگر فقط یک آبجکت برگشت
          data = [res.data];
        }

        if (!data || data.length === 0) {
          setText(true);
          setPosts([]);
        } else {
          setPosts(data);
          setText(false);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.error("Error fetching study opportunities:", err.response?.data || err.message);
        setLoader(false);
        setText(true);
        setError(err.response?.status || "network");
      });
  }, [id]);

  // تابع کمکی برای گرفتن اطلاعات امن
  const getOpportunity = (post) => {
    // حالت‌های مختلف ساختار داده
    if (post.studyOpportunity?.[0]) return post.studyOpportunity[0];
    if (post.studyOpportunity) return post.studyOpportunity;
    if (post.opportunity) return post.opportunity;
    return post; // اگر خود post اطلاعات رو داره
  };

  return (
    <div className="send-resume-job">
      <Header title="درخواست های من" />
      <div className="job-list">
        <div className="job-list-body-r">
          {loader ? (
            <div className="spinner">
              <Loader
                type="TailSpin"
                color="rgb(236, 177, 28)"
                height={80}
                width={80}
              />
            </div>
          ) : text || posts.length === 0 ? (
            <p className="font">
              {error === 401 || error === 403
                ? "لطفا دوباره وارد شوید"
                : "درخواستی وجود ندارد"}
            </p>
          ) : (
            posts.map((post) => {
              const opp = getOpportunity(post);
              const linkId = opp?.id || opp?._id || post._id;

              return (
                <Link
                  to={`/education-single/${linkId}`}
                  key={post._id || linkId}
                  className="job-list-item"
                >
                  <div className="job-list-title-r">
                    <div className="job-list-text-fix">
                      <h6>{opp?.country || "—"}</h6>
                    </div>
                    <h5>{opp?.title || "بدون عنوان"}</h5>
                    <p className="two-line">
                      {opp?.responsibility || opp?.description || ""}
                    </p>
                  </div>

                  <div className="job-list-title-icon">
                    <img src={mortarboard} alt="education" />
                  </div>
                </Link>
              );
            })
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default SendResumeEducation;